import useSEO from "../hooks/useSEO";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import Stats from "../sections/Stats";
import Timeline from "../sections/Timeline";
import CTASection from "../sections/CTASection";
import { BRAND, IMAGES, WHY_US } from "../data/content";

export default function About() {
  useSEO({
    title: "About Us",
    description:
      "Learn about Ideal Entertainment — a global production house creating innovative films, music and soulful experiences for audiences worldwide.",
  });
  return (
    <>
      <PageHero
        overline="About Ideal Entertainment"
        title="A global home for soulful, original entertainment"
        subtitle={BRAND.tagline}
        image={IMAGES.aboutPortrait}
      />

      <section className="section-y">
        <div className="container-x grid grid-cols-1 gap-16 lg:grid-cols-2 lg:items-center">
          <Reveal>
            <div className="relative overflow-hidden rounded-3xl border border-white/5">
              <img
                src="https://images.unsplash.com/photo-1632187981988-40f3cbaeef5e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400"
                alt="On set"
                className="w-full object-cover"
              />
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <span className="overline">Our Mission</span>
            <h2 className="mt-5 font-playfair text-3xl font-bold leading-tight tracking-tight sm:text-4xl">
              Creating innovative content &amp; soulful experiences
            </h2>
            <p className="mt-6 text-base font-light leading-relaxed text-neutral-400">
              {BRAND.mission}
            </p>
            <p className="mt-4 text-base font-light leading-relaxed text-neutral-400">
              We collaborate with multi-faceted, talented artists and brands to produce
              original, theme-based films, music and live events — from intimate musicals
              to virtual-reality cinema and large-scale concert films — bringing quality
              entertainment to a worldwide platform.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="border-y border-white/5 bg-[#070707] py-20">
        <div className="container-x grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-white/5 bg-white/5 sm:grid-cols-2 lg:grid-cols-4">
          {WHY_US.map((w, i) => (
            <Reveal key={w.title} delay={i * 0.06}>
              <div className="h-full bg-[#0a0a0a] p-8">
                <span className="font-playfair text-3xl text-gold/40">0{i + 1}</span>
                <h3 className="mt-4 font-playfair text-lg text-white">{w.title}</h3>
                <p className="mt-2 text-sm font-light text-neutral-400">{w.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <Stats />
      <Timeline />
      <CTASection />
    </>
  );
}
